import React from "react";
import { Carousel } from "react-bootstrap";
import "./CarouselClass.css";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";

class CarouselClass extends React.Component {
  constructor() {
    super();
    this.state = { screenWidth: null, imgsLoaded: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowDimensions());
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ screenWidth: window.innerWidth });
  }

  imgOnLoad = () => {
    this.setState({ imgsLoaded: this.setState.imgsLoaded + 1 });
  };

  render() {
    const screenWidth = this.state.screenWidth;
    return (
      <Carousel>
        <Carousel.Item>
          <div
            style={{
              height: screenWidth >= 760 ? "300px" : "600px",
              display: this.state.imgsLoaded < 4 ? "block" : "none",
            }}
          >
            <LoadingSpinner spinner />
          </div>
          <div
            style={{ display: this.state.imgsLoaded <= 4 ? "none" : "block" }}
          >
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/videos_header_1_pc.webp`}
                width="1800"
                height="360"
              />
              <img
                className="d-block video-carousel-image"
                src={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/videos_header_1_mob.webp`}
                width="800"
                height="400"
                alt="It is a paster coloured image with colourful squares on the left top and right bottom corner. Meendu is standing on the left botton corner and Muskaan standing on the right top corner. It has a quote written by MeenduToons in the center of the image. It reads: 'It is important to become a good human before becoming anything else in life.'"
                onLoad={this.imgOnLoad}
              />
            </picture>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div
            style={{
              height: screenWidth >= 760 ? "300px" : "600px",
              display: this.state.imgsLoaded < 4 ? "block" : "none",
            }}
          >
            <LoadingSpinner />
          </div>
          <div
            style={{ display: this.state.imgsLoaded <= 4 ? "none" : "block" }}
          >
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/videos_header_2_pc.webp`}
                width="1800"
                height="360"
              />
              <img
                className="d-block video-carousel-image"
                src={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/videos_header_2_mob.webp`}
                width="800"
                height="400"
                alt="It is a white image with pastel coloured smoke effect. Meendu's mom is standing in the bottom left corner. The quote in the center of the image reads: 'treat others the way you want to be treated.' It is an anonymously used quote."
                onLoad={this.imgOnLoad}
              />
            </picture>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div
            style={{
              height: screenWidth >= 760 ? "300px" : "600px",
              display: this.state.imgsLoaded < 4 ? "block" : "none",
            }}
          >
            <LoadingSpinner />
          </div>
          <div
            style={{ display: this.state.imgsLoaded <= 4 ? "none" : "block" }}
          >
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/videos_header_3_pc.webp`}
                width="1800"
                height="360"
              />
              <img
                className="d-block video-carousel-image"
                src={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/videos_header_3_mob.webp`}
                width="800"
                height="400"
                alt="It is a white image with coloured sprinkles spread over over it. It also has colourful ice cream images as top and bottom border. An anonymous quote in the center of the image reads: 'In a world where you can be anything, Be Kind.'"
                onLoad={this.imgOnLoad}
              />
            </picture>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div
            style={{
              height: screenWidth >= 760 ? "300px" : "600px",
              display: this.state.imgsLoaded < 4 ? "block" : "none",
            }}
          >
            <LoadingSpinner />
          </div>
          <div
            style={{ display: this.state.imgsLoaded <= 4 ? "none" : "block" }}
          >
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/videos_header_4_pc.webp`}
                width="1800"
                height="360"
              />
              <img
                className="d-block video-carousel-image"
                src={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/videos_header_4_mob.webp`}
                width="800"
                height="400"
                alt="It is a shaded blue colour image with snowflakes all over it. Meendu is standing in the bottom right corner. The quote written by MeenduToons in the center of the image reads: 'We need to create a society where being 'too nice' is not seen as a drawback.'"
                onLoad={this.imgOnLoad}
              />
            </picture>
          </div>
        </Carousel.Item>
      </Carousel>
    );
  }
}

export default CarouselClass;
